import VueRouter from "vue-router";
import Vue from "vue";
import paths from "../paths";

Vue.use(VueRouter);

Vue.router = new VueRouter({
    routes: paths,
    scrollBehavior(to, from, savedPosition) {
        if (savedPosition) {
            return savedPosition;
        } else {
            return { x: 0, y: 0 };
        }
    },
})

export default Vue.router;
